import { Slide, ToastContainerProps } from 'react-toastify';

export const getToastConfig = (): ToastContainerProps => {
    return {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        newestOnTop: false,
        closeOnClick: true,
        rtl: false,
        pauseOnFocusLoss: true,
        draggable: true,
        pauseOnHover: true,
        theme: 'colored',
        limit: 2,
        transition: Slide,
    };
};
